import { PALETTE, FONT_DISPLAY, FONT_MONO } from "@/components/cobrain/tokens";

/* "Us vs the alternatives" — promotes the strongest differentiator out of
   the FAQ and into a scannable matrix. No prices, only shape. */

const COLS = [
  { key: "us", label: "HireEva Services", highlight: true },
  { key: "agency", label: "AI agency", highlight: false },
  { key: "consult", label: "Big consultancy", highlight: false },
  { key: "hire", label: "Hiring in-house", highlight: false },
];

const ROWS: { row: string; cells: Record<string, string> }[] = [
  {
    row: "Time to first working thing",
    cells: { us: "Days", agency: "Weeks", consult: "A quarter or more", hire: "Months to recruit" },
  },
  {
    row: "Who actually builds it",
    cells: { us: "Our team, led by your assigned engineer", agency: "Subcontractors, often", consult: "A junior team", hire: "Your new hire, alone" },
  },
  {
    row: "Whose software",
    cells: { us: "Ours — we ship fixes ourselves", agency: "Reselling somebody else's", consult: "Whatever the partner deck says", hire: "Whatever they pick" },
  },
  {
    row: "Commitment",
    cells: { us: "Audit, then a 3-month first term, then month to month. Yours once paid in full", agency: "Monthly retainer", consult: "Six figures, staged", hire: "Full-time headcount" },
  },
  {
    row: "Told when not to build",
    cells: { us: "Yes — on the first call", agency: "Rarely", consult: "Not their incentive", hire: "Depends on the person" },
  },
];

export function CompareMatrix() {
  return (
    <div>
      <div className="svc-matrix-scroll" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
        <table style={{
          width: "100%", minWidth: 720, borderCollapse: "separate", borderSpacing: 0,
          fontSize: 14, color: PALETTE.ink2,
        }}>
          <caption className="sr-only">How HireEva Services compares to an AI agency, a large consultancy, and hiring in-house</caption>
          <thead>
            <tr>
              <th scope="col" style={{ textAlign: "left", padding: "0 14px 12px 0", width: "22%" }}>
                <span className="sr-only">Comparison</span>
              </th>
              {COLS.map((c) => (
                <th
                  key={c.key}
                  scope="col"
                  style={{
                    textAlign: "left", padding: "10px 14px", verticalAlign: "bottom",
                    fontFamily: FONT_DISPLAY, fontWeight: 400, fontSize: 19, letterSpacing: "-0.01em",
                    color: c.highlight ? PALETTE.ink : PALETTE.muted,
                    background: c.highlight ? "rgba(196,130,58,0.10)" : "transparent",
                    borderTopLeftRadius: c.highlight ? 14 : 0, borderTopRightRadius: c.highlight ? 14 : 0,
                    borderTop: c.highlight ? `1px solid rgba(196,130,58,0.35)` : "none",
                    borderLeft: c.highlight ? `1px solid rgba(196,130,58,0.35)` : "none",
                    borderRight: c.highlight ? `1px solid rgba(196,130,58,0.35)` : "none",
                  }}
                >
                  {c.highlight && (
                    <span style={{ display: "block", fontFamily: FONT_MONO, fontSize: 9.5, letterSpacing: "0.14em", textTransform: "uppercase", color: PALETTE.amber, marginBottom: 6 }}>
                      You are here
                    </span>
                  )}
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r, ri) => {
              const last = ri === ROWS.length - 1;
              return (
                <tr key={r.row}>
                  <th scope="row" style={{
                    textAlign: "left", padding: "14px 14px 14px 0", fontWeight: 600, fontSize: 13.5,
                    color: PALETTE.ink, borderTop: `1px solid ${PALETTE.line}`, verticalAlign: "top",
                  }}>
                    {r.row}
                  </th>
                  {COLS.map((c) => (
                    <td
                      key={c.key}
                      style={{
                        padding: "14px", verticalAlign: "top", lineHeight: 1.45,
                        color: c.highlight ? PALETTE.ink : PALETTE.muted,
                        fontWeight: c.highlight ? 600 : 400,
                        background: c.highlight ? "rgba(196,130,58,0.10)" : "transparent",
                        borderTop: `1px solid ${c.highlight ? "rgba(196,130,58,0.22)" : PALETTE.line}`,
                        borderLeft: c.highlight ? `1px solid rgba(196,130,58,0.35)` : "none",
                        borderRight: c.highlight ? `1px solid rgba(196,130,58,0.35)` : "none",
                        borderBottom: c.highlight && last ? `1px solid rgba(196,130,58,0.35)` : "none",
                        borderBottomLeftRadius: c.highlight && last ? 14 : 0,
                        borderBottomRightRadius: c.highlight && last ? 14 : 0,
                      }}
                    >
                      {r.cells[c.key]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p style={{ margin: "12px 0 0", fontSize: 12, color: PALETTE.muted }}>
        Swipe the table sideways on mobile.
      </p>
    </div>
  );
}

export default CompareMatrix;
